import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { Canceler } from 'axios';
import { noop } from 'lodash';

import { Inquiry } from '../models/inquiry';

export class InquiryApi {
    constructor(protected baseUrl: string) {}

    private canceler: Canceler | undefined;

    public get = (id: number): Promise<ApiResult<Inquiry>> => {
        this.canceler?.();

        return safeRequest(
            () =>
                request.get(`${this.baseUrl}/inquiries/${id}`, {
                    cancelToken: new request.CancelToken(c => (this.canceler = c)),
                }),
            response => Inquiry.fromPlainObject(response.data)
        );
    };

    public cget = (params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<Inquiry>>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/inquiries`, { params }),
            response => {
                response.data.items = response.data.items.map(Inquiry.fromPlainObject);
                return response.data;
            }
        );
    };

    public decline(inquiryId: number, supplierDeclinedReason: string): Promise<ApiResult<void>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/inquiries/${inquiryId}/decline`, { supplierDeclinedReason }),
            noop
        );
    }

    public export(params: URLSearchParams): Promise<ApiResult<Blob>> {
        const exportFields = ['number', 'status', 'title', 'responsibleContact.fullName', 'createdAt'];
        params.append('fields', exportFields.join(','));
        return safeRequest(
            () => request.get(`${this.baseUrl}/inquiry.csv`, { params, responseType: 'blob' }),
            response => response.data
        );
    }
}
